import { render, staticRenderFns } from "./personalBaseInfo.vue?vue&type=template&id=5bab39a6&scoped=true"
import script from "./personalBaseInfo.vue?vue&type=script&lang=js"
export * from "./personalBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./personalBaseInfo.vue?vue&type=style&index=0&id=5bab39a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bab39a6",
  null
  
)

export default component.exports